// src/components/Public/LanguageModal.jsx
import React from 'react';

const LanguageModal = ({ isOpen, onClose, onSelectLanguage }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="language-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Select Language / Selecciona Idioma</h2>
        <div className="language-options">
          <button onClick={() => onSelectLanguage('es')} className="language-btn">
            <span className="flag">🇪🇸</span> Español
          </button>
          <button onClick={() => onSelectLanguage('en')} className="language-btn">
            <span className="flag">🇺🇸</span> English
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
